import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { StructuredPresenterInterface } from '../structuredSelectPresenter/types'
import structuredSelectPresenter from '../structuredSelectPresenter'
import {  getPureUsername, isObserver } from '../../../lib/username/username'



const getObservers = (state: State) => {

  if (!state.room.room) return []

  return Array.from(state.room.room.participants.values()).concat([state.room.room.localParticipant as any])
    .filter(({identity}) => isObserver(identity))
    .map(({identity}) => getPureUsername(identity)) 
}

const getParticipantInformationFromBTID = (state: State): StructuredPresenterInterface[] => {

  return getObservers(state)
    .map(BTID => structuredSelectPresenter(state, { BTID }))

}

export default createSelector<State, any, StructuredPresenterInterface[]>(
  [getParticipantInformationFromBTID],
  (
    participantInformation: StructuredPresenterInterface[]
  ) => {

    return participantInformation

  })